import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the form data to a server
    alert('Thank you for your message! We will get back to you soon.');
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  return (
    <div className="contact-page">
      <section className="contact-hero">
        <h1 className="contact-title">Contact Us</h1>
        <p className="contact-subtitle">Get in touch with us for your construction needs</p>
      </section>

      <section className="contact-section">
        <div className="contact-container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2 className="section-heading">Get In Touch</h2>
              <p className="contact-description">
                We're here to help you with all your construction needs. 
                Feel free to reach out to us through any of the following channels.
              </p>

              <div className="info-cards">
                <div className="info-card-item">
                  <div className="info-icon">📍</div>
                  <div className="info-content">
                    <h3>Address</h3>
                    <p>Mahalaxmi-2, Lalitpur<br />Nepal</p>
                  </div>
                </div>

                <div className="info-card-item">
                  <div className="info-icon">📧</div>
                  <div className="info-content">
                    <h3>Email</h3>
                    <p>
                      <a href={`mailto:karmataranirman@gmail.com`}>
                        karmataranirman@gmail.com
                      </a>
                    </p>
                  </div>
                </div>

                <div className="info-card-item">
                  <div className="info-icon">📞</div>
                  <div className="info-content">
                    <h3>Phone</h3>
                    <p>
                      <a href={`tel:9766544171`}>
                        9766544171
                      </a>
                    </p>
                  </div>
                </div>
              </div>

              <div className="company-details">
                <h3>Company Information</h3>
                <div className="detail-row">
                  <span className="detail-label">Company Name:</span>
                  <span className="detail-value">Karmatara Nirman Sewa Pvt. Ltd.</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Nepali Name:</span>
                  <span className="detail-value">कर्मतारा निर्माण सेवा प्रा. लि.</span>
                </div>
              </div>
            </div>

            <div className="contact-form-container">
              <h2 className="section-heading">Send Us a Message</h2>
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Your Name"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="your.email@example.com"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Phone</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Your Phone Number"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    placeholder="Your Message"
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-primary">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;

